import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class InductionUserLookupModel extends ModelBase<InductionUserLookupModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = InductionUserLookupModel.DEFAULT_ID;

    @observable
    public displayName: string = InductionUserLookupModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = InductionUserLookupModel.DEFAULT_ID;
        this.displayName = InductionUserLookupModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: InductionUserLookupDTO): void {
        this.id = dto.id;
        this.displayName = `${dto.lastName}, ${dto.firstName}`;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: InductionUserLookupDTO[]): InductionUserLookupModel[] {
        const types: InductionUserLookupModel[] = [];

        for (const dto of dtos) {
            const model = new InductionUserLookupModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface InductionUserLookupDTO {
    id: string;
    firstName: string;
    lastName: string;
}
